<template>
  <div class="comment-wrap" id="comment">
    <el-row class="hot-comment">
      <el-col class="commodityEvaluation">商品评价</el-col>
      <el-col v-if="commentRateTxt > 0" :span="3" class="good-rate-wrap">
        好评度:
        <div class="good-rate">
          <span class="rate_txt">{{ commentRateTxt }}</span>
          %
        </div>
      </el-col>
      <el-col :span="21" v-if="this.comment_param.supplier === 'jd'">
        <span
          class="hot-tag"
          :class="{ actived: item.rid === currentHotComment }"
          v-for="item in hotComments"
          :key="item.id"
          @click="
            currentHotComment = item.rid;
            commentIndex = -1;
            Pinjia(1, 0);
          "
          >{{ item.name }}({{ item.count }})</span
        >
      </el-col>
      <el-col :span="21" v-else-if="this.comment_param.supplier === 'suning'">
        <span class="sn-hot" v-for="item in hotComments" :key="item.labelName"
          >{{ item.labelName }}({{ totalFormat(item.labelCnt) }})</span
        >
      </el-col>
    </el-row>
    <div
      class="comment-title"
      v-if="
        this.comment_param.supplier === 'jd' ||
          this.comment_param.supplier === 'suning'
      "
    >
      <span
        :class="{ actived: commentIndex == 0 }"
        @click="
          commentIndex = 0;
          currentHotComment = 0;
          Pinjia(1, 0);
        "
        >全部评价 ({{ totalItems[0] }})</span
      >
      <span
        :class="{ actived: commentIndex == 7 }"
        @click="
          commentIndex = 7;
          currentHotComment = 0;
          Pinjia(1, 7);
        "
        >视频晒单 ({{ totalItems[5] }})</span
      >
      <span
        :class="{ actived: commentIndex == 5 }"
        @click="
          commentIndex = 5;
          currentHotComment = 0;
          Pinjia(1, 5);
        "
        >追评 ({{ totalItems[4] }})</span
      >
      <span
        :class="{ actived: commentIndex == 3 }"
        @click="
          commentIndex = 3;
          currentHotComment = 0;
          Pinjia(1, 3);
        "
        >好评 ({{ totalItems[1] }})</span
      >
      <span
        :class="{ actived: commentIndex == 2 }"
        @click="
          commentIndex = 2;
          currentHotComment = 0;
          Pinjia(1, 2);
        "
        >中评 ({{ totalItems[2] }})</span
      >
      <span
        :class="{ actived: commentIndex == 1 }"
        @click="
          commentIndex = 1;
          currentHotComment = 0;
          Pinjia(1, 1);
        "
        >差评 ({{ totalItems[3] }})</span
      >
      <span
        v-if="
          comment_param.supplier === 'jd' ||
            (comment_param.supplier == 'suning' && comment_param.clusterId)
        "
        :class="{ actived: showCurrentComment === true }"
      >
        <el-checkbox
          v-model="showCurrentComment"
          @change="
            Pinjia();
            getSatisfy();
          "
        ></el-checkbox
        >&nbsp;只看当前商品评价
      </span>
    </div>
    <div
      class="comment-title"
      v-else-if="this.comment_param.supplier === 'wangyi'"
    >
      <span
        v-for="(item, index) in totalItems"
        :key="index"
        :class="{ actived: commentIndex == item.name }"
        @click="
          commentIndex = item.name;
          currentHotComment = 0;
          Pinjia(1, 0);
        "
        >{{ item.name }} ({{ totalFormat(item.strCount) }})</span
      >
    </div>
    <div class="reviews-list" v-if="this.comment_param.supplier === 'jd'">
      <div
        class="reviews-item clearfix"
        v-for="(item, index) in comments"
        :key="item.id"
      >
        <div class="review-header">
          <div class="Names">
            <img :src="'//' + item.userImageUrl" :alt="item.nickname" />
          </div>
          <span class="nickname">{{ item.nickname }}</span>
          <div class="NameBox">{{ item.userLevelName }}</div>
        </div>
        <div class="review-item-content clearfix">
          <div class="review-date">
            <el-rate
              v-model="item.score"
              disabled
              disabled-void-color="#999"
              :colors="colors"
            ></el-rate>
          </div>
          <div class="review-description">{{ item.content }}</div>
          <div class="clearfix">
            <div
              class="imgBox"
              v-if="
                Object.keys(Object(item.images)).length > 0 ||
                  Object.keys(Object(item.videos)).length > 0
              "
            >
              <template v-if="Object.keys(Object(item.videos)).length > 0">
                <div class="imgList" v-for="i in item.videos" :key="i.id">
                  <img :src="i.mainUrl" />
                  <img
                    class="play-btn"
                    @click="playVideo(i.remark, index)"
                    src="https://ossimg.shangbanzugroup.com/image/icons/dsp/zanting.png"
                  />
                </div>
              </template>
              <div
                class="imgList not-video"
                v-for="i in item.images"
                :key="i.id"
              >
                <img
                  :src="i.imgUrl"
                  alt="goods"
                  @click="showBigCommentImage(i.imgUrl, index)"
                />
              </div>
            </div>
          </div>
          <div v-if="item.afterUserComment">
            <div class="after-comment">[购买{{ item.afterDays }}天后追评]</div>
            <div class="review-description">
              {{ item.afterUserComment.content }}
            </div>
            <div
              class="imgBox"
              v-if="
                Object.keys(Object(item.afterImages)).length > 0 ||
                  Object.keys(Object(item.afterVideos)).length > 0
              "
            >
              <template v-if="Object.keys(Object(item.afterVideos)).length > 0">
                <div class="imgList" v-for="i in item.afterVideos" :key="i.id">
                  <img :src="i.mainUrl" />
                  <img
                    class="play-btn"
                    @click="playVideo(i.remark, index)"
                    src="https://ossimg.shangbanzugroup.com/image/icons/dsp/zanting.png"
                  />
                </div>
              </template>
              <div
                class="imgList not-video"
                v-for="i in item.afterImages"
                :key="i.id"
              >
                <img
                  :src="i.imgUrl"
                  alt="goods"
                  @click="showBigCommentImage(i.imgUrl, index)"
                />
              </div>
            </div>
          </div>
          <div class="PlsPage" v-if="bigImage[index]">
            <img :src="bigImage[index]" @click="clearCommentImage(index)" />
          </div>
          <div class="PlsPage" v-else-if="playingVideo[index]">
            <video width="300" controls autoplay :src="playingVideo[index]" />
          </div>
          <div class="titleBox">
            <span class="ng-binding">{{ item.referenceName }}</span>
            <span class="ng-binding">{{ item.referenceTime }}</span>
          </div>
        </div>
      </div>
    </div>
    <div
      class="reviews-list"
      v-else-if="this.comment_param.supplier === 'suning'"
    >
      <div
        class="reviews-item clearfix"
        v-for="(item, index) in comments"
        :key="item.id"
      >
        <div class="review-header">
          <div class="Names">
            <img
              :src="'//' + item.userInfo.imgUrl"
              :alt="item.userInfo.nickName"
            />
          </div>
          <span class="nickname">{{ item.userInfo.nickName }}</span>
          <div class="NameBox">{{ item.userInfo.levelName }}</div>
        </div>
        <div class="review-item-content clearfix">
          <div class="review-date">
            <el-rate
              v-model="item.qualityStar"
              disabled
              disabled-void-color="#999"
              :colors="colors"
            ></el-rate>
          </div>
          <div class="review-description">{{ item.content }}</div>
          <div class="clearfix">
            <div class="imgBox" v-if="item.picVideoFlag && item.picVideInfo">
              <template>
                <div
                  class="imgList not-video"
                  v-for="i in item.picVideInfo.imageInfo"
                  :key="i.id"
                >
                  <img
                    :src="i.linkUrl"
                    @click="showBigCommentImage(i.linkUrl, index)"
                  />
                </div>
              </template>
            </div>
          </div>
          <div v-if="item.againFlag">
            <div class="after-comment">
              {{ item.againReview.publishTimeStr }}
            </div>
            <div class="review-description">
              {{ item.againReview.againContent }}
            </div>
            <div class="imgBox" v-if="item.againFlag">
              <div
                class="imgList not-video"
                v-for="(i, idx) in item.againReviewImgList"
                :key="idx"
              >
                <img
                  :src="'//' + i.imgId + '_100x100.jpg'"
                  alt="goods"
                  @click="showBigCommentImage(i.imgId + '_400x400.jpg', index)"
                />
              </div>
            </div>
          </div>
          <div class="PlsPage" v-if="bigImage[index]">
            <img :src="bigImage[index]" @click="clearCommentImage(index)" />
          </div>
          <div class="PlsPage" v-else-if="playingVideo[index]">
            <video width="300" controls autoplay :src="playingVideo[index]" />
          </div>
          <div class="titleBox">
            <span class="ng-binding">{{ item.referenceName }}</span>
            <span class="ng-binding">{{ item.referenceTime }}</span>
          </div>
        </div>
      </div>
    </div>
    <div
      class="reviews-list"
      v-else-if="this.comment_param.supplier === 'wangyi'"
    >
      <div
        class="reviews-item clearfix"
        v-for="(item, index) in comments"
        :key="item.id"
      >
        <div class="review-header">
          <div class="Names">
            <img :src="item.frontUserAvatar" />
          </div>
          <span class="nickname">{{ item.frontUserName }}</span>
          <!-- <div class="NameBox">{{ item.memberLevel }}</div> -->
        </div>
        <div class="review-item-content clearfix">
          <div class="review-date">
            <el-rate
              v-model="item.star"
              disabled
              disabled-void-color="#999"
              :colors="colors"
            ></el-rate>
          </div>
          <div class="review-description">{{ item.content }}</div>
          <div class="clearfix">
            <div class="imgBox" v-if="item.picList && item.picList.length > 0">
              <template>
                <div
                  class="imgList not-video"
                  v-for="(i, idx) in item.picList"
                  :key="idx"
                >
                  <img :src="i" @click="showBigCommentImage(i, index)" />
                </div>
              </template>
            </div>
          </div>
          <div v-if="item.appendCommentVO">
            <div class="after-comment">
              {{
                item.appendCommentVO.createTime
                  | dateFormat("YYYY-MM-DD hh:mm:ss")
              }}
            </div>
            <div class="review-description">
              {{ item.appendCommentVO.content }}
            </div>
            <div
              class="imgBox"
              v-if="
                item.appendCommentVO.picList &&
                  item.appendCommentVO.picList.length > 0
              "
            >
              <div
                class="imgList not-video"
                v-for="(i, idx) in item.appendCommentVO.picList"
                :key="idx"
              >
                <img
                  :src="i"
                  alt="goods"
                  @click="showBigCommentImage(i, index)"
                />
              </div>
            </div>
          </div>
          <div class="PlsPage" v-if="bigImage[index]">
            <img :src="bigImage[index]" @click="clearCommentImage(index)" />
          </div>
          <div class="PlsPage" v-else-if="playingVideo[index]">
            <video width="300" controls autoplay :src="playingVideo[index]" />
          </div>
          <div class="titleBox">
            <span class="ng-binding">{{ item.skuInfo[0] }}</span>
            <span class="ng-binding">{{
              item.createTime | dateFormat("YYYY-MM-DD hh:mm:ss")
            }}</span>
          </div>
        </div>
      </div>
    </div>
    <el-pagination
      @current-change="handleCurrentChange"
      :current-page.sync="currentPage"
      :page-size="10"
      layout="prev, pager, next, jumper"
      :total="maxTotal"
    ></el-pagination>
  </div>
</template>

<script>
export default {
  props: { goodsInfo: Object, comment_param: Object },
  data() {
    return {
      commentRateTxt: 0,
      totalItems: [],
      hotComments: [],
      comments: [],
      currentPage: 1,
      maxTotal: 0,
      commentIndex: 0,
      rate: 4,
      colors: ["#E2333F", "#E2333F", "#E2333F"],
      bigImage: [],
      currentHotComment: 0,
      playingVideo: [],
      showCurrentComment: false,
      reviewCounts: {}
    };
  },
  mounted() {
    if (
      this.goodsInfo.product_comment_summary &&
      this.goodsInfo.product_comment_summary.good_rate
    ) {
      this.commentRateTxt = parseFloat(
        (this.goodsInfo.product_comment_summary.good_rate * 100).toFixed(2)
      );
    }
    if (this.comment_param.supplier === "suning") {
      this.getSatisfy();
    } else if (
      this.comment_param.supplier === "wangyi" &&
      this.comment_param.wangyiId
    ) {
      this.commentIndex = "全部";
      this.getCommentList();
      this.getRate();
    }
    this.Pinjia();
  },
  methods: {
    Pinjia(pageNum = 1, score = this.commentIndex) {
      if (this.comment_param.supplier === "jd") {
        this.getJdEvaluation(pageNum, score);
      } else if (this.comment_param.supplier === "suning") {
        this.getSnEvaluation(pageNum, score);
      } else if (
        this.comment_param.supplier === "wangyi" &&
        this.comment_param.wangyiId
      ) {
        this.getWyEvaluation(pageNum, score);
      }
    },
    getJdEvaluation(pageNum = 1, score = this.commentIndex) {
      this.totalItems = [];
      this.playingVideo = [];
      this.currentPage = pageNum;
      pageNum--;
      var url = "https://club.jd.com/comment/productPageComments.action?";
      if (this.showCurrentComment) {
        url = "https://club.jd.com/comment/skuProductPageComments.action?";
      }
      var list =
        "productId=" +
        this.goodsInfo.sku +
        "&score=" +
        score +
        "&sortType=5&page=" +
        pageNum +
        "&rid=" +
        this.currentHotComment +
        "&pageSize=10&isShadowSku=0&fold=1";
      this.$http.jsonp(url + list).then(function(res) {
        let pruductesFun = res.data.productCommentSummary;
        if (
          !(
            this.goodsInfo.product_comment_summary &&
            this.goodsInfo.product_comment_summary.good_rate
          )
        ) {
          this.commentRate = pruductesFun.goodRate * 100 + "%";
        }
        this.comments = res.data.comments;
        this.maxTotal = res.data.maxTotal * 10;
        if (this.maxTotal > 500) {
          this.maxTotal = 500;
        }
        this.$emit("setTotal", pruductesFun.commentCountStr);
        this.totalItems.push(pruductesFun.commentCountStr);
        this.totalItems.push(pruductesFun.goodCountStr);
        this.totalItems.push(pruductesFun.generalCountStr);
        this.totalItems.push(pruductesFun.poorCountStr);
        this.totalItems.push(pruductesFun.afterCountStr);
        this.totalItems.push(pruductesFun.videoCountStr);
        this.hotComments = res.data.hotCommentTagStatistics;
      });
      this.bigImage = [];
    },
    getSnEvaluation(pageNum = 1, score = this.commentIndex) {
      let type = this.showCurrentComment ? "cluster" : "general";
      this.currentPage = pageNum;
      let keyword;
      switch (this.commentIndex) {
        case 0:
          keyword = "total";
          if (this.reviewCounts.totalCount) {
            this.maxTotal = this.reviewCounts.totalCount;
          }
          break;
        case 1:
          keyword = "bad";
          if (this.reviewCounts.oneStarCount) {
            this.maxTotal = this.reviewCounts.oneStarCount;
          }
          break;
        case 2:
          keyword = "normal";
          if (
            this.reviewCounts.threeStarCount ||
            this.reviewCounts.twoStarCount
          ) {
            this.maxTotal =
              this.reviewCounts.threeStarCount + this.reviewCounts.twoStarCount;
          }
          break;
        case 3:
          keyword = "good";
          if (
            this.reviewCounts.fiveStarCount ||
            this.reviewCounts.fourStarCount
          ) {
            this.maxTotal =
              this.reviewCounts.fiveStarCount + this.reviewCounts.fourStarCount;
          }
          break;
        case 5:
          keyword = "again";
          if (this.reviewCounts.againCount) {
            this.maxTotal = this.reviewCounts.againCount;
          }
          break;
        case 7:
          keyword = "show";
          if (this.reviewCounts.picFlagCount) {
            this.maxTotal = this.reviewCounts.picFlagCount;
          }
          break;
        default:
          break;
      }
      let url =
        "https://review.suning.com/ajax/cluster_review_lists/" +
        type +
        "-" +
        this.comment_param.clusterId +
        "-" +
        this.comment_param.sku +
        "-" +
        this.comment_param.vendorCode +
        "-" +
        keyword +
        "-" +
        pageNum +
        "-" +
        "default-10" +
        "-----reviewList.htm";
      this.$http
        .jsonp(url, {
          jsonp: "callback",
          jsonpCallback: "reviewList",
          dataType: "jsonp"
        })
        .then(function(res) {
          this.comments = res.data.commodityReviews;
        })
        .catch(err => {
          console.log(err);
        });
    },
    getWyEvaluation(pageNum = 1) {
      this.currentPage = pageNum;
      let url =
        "https://wy.shangbanzugroup.com/xhr/comment/listByItemByTag.json";
      this.$http
        .jsonp(url, {
          jsonp: "callback",
          dataType: "json",
          params: {
            itemId: this.comment_param.wangyiId,
            tag: this.commentIndex,
            size: 10,
            page: this.currentPage,
            orderBy: 0,
            oldItemTag: "",
            oldItemOrderBy: 0,
            tagChanged: 0
          }
        })
        .then(res => {
          this.comments = res.data.data.commentList;
          this.maxTotal = res.data.data.pagination.total;
          console.log(this.maxTotal);
        });
    },
    getSatisfy() {
      if (this.comment_param.supplier !== "suning") {
        return;
      }
      this.totalItems = [];
      let type = "general";
      let url =
        "https://review.suning.com/ajax/review_count/" +
        type +
        "-" +
        this.goodsInfo.comment_param.clusterId +
        "-" +
        this.goodsInfo.comment_param.sku +
        "-" +
        this.goodsInfo.comment_param.vendorCode +
        "-----satisfy.htm";
      this.$http
        .jsonp(url, {
          jsonp: "callback",
          jsonpCallback: "satisfy",
          dataType: "jsonp"
        })
        .then(function(res) {
          this.reviewCounts = res.data.reviewCounts[0];
          let totalCount =
            this.reviewCounts.totalCount > 10000
              ? parseInt(this.reviewCounts.totalCount / 10000) + "万+"
              : this.reviewCounts.totalCount;
          this.totalItems.push(totalCount);
          this.$emit("setTotal", totalCount);
          let goodNum =
            this.reviewCounts.fiveStarCount + this.reviewCounts.fourStarCount;
          goodNum =
            goodNum > 10000 ? parseInt(goodNum / 10000) + "万+" : goodNum;
          this.totalItems.push(goodNum);
          let midNum =
            this.reviewCounts.threeStarCount + this.reviewCounts.twoStarCount;
          midNum = midNum > 10000 ? parseIntmidNum / 10000 + "万+" : midNum;
          this.totalItems.push(midNum);
          let oneStarCount =
            this.reviewCounts.oneStarCount > 10000
              ? parseInt(this.reviewCounts.oneStarCount / 10000) + "万+"
              : this.reviewCounts.oneStarCount;
          this.totalItems.push(oneStarCount);
          let againCount =
            this.reviewCounts.againCount > 10000
              ? parseInt(this.reviewCounts.againCount / 10000) + "万+"
              : this.reviewCounts.againCount;
          this.totalItems.push(againCount);
          let picFlagCount =
            this.reviewCounts.picFlagCount > 10000
              ? parseInt(this.reviewCounts.picFlagCount / 10000) + "万+"
              : this.reviewCounts.picFlagCount;
          this.totalItems.push(picFlagCount);
          this.commentRateTxt = parseInt(
            ((this.reviewCounts.fiveStarCount +
              this.reviewCounts.fourStarCount) /
              this.reviewCounts.totalCount) *
              100
          );
          switch (this.commentIndex) {
            case 0:
              if (this.reviewCounts.totalCount) {
                this.maxTotal = this.reviewCounts.totalCount;
              }
              break;
            case 1:
              if (this.reviewCounts.oneStarCount) {
                this.maxTotal = this.reviewCounts.oneStarCount;
              }
              break;
            case 2:
              if (
                this.reviewCounts.threeStarCount ||
                this.reviewCounts.twoStarCount
              ) {
                this.maxTotal =
                  this.reviewCounts.threeStarCount +
                  this.reviewCounts.twoStarCount;
              }
              break;
            case 3:
              if (
                this.reviewCounts.fiveStarCount ||
                this.reviewCounts.fourStarCount
              ) {
                this.maxTotal =
                  this.reviewCounts.fiveStarCount +
                  this.reviewCounts.fourStarCount;
              }
              break;
            case 5:
              if (this.reviewCounts.againCount) {
                this.maxTotal = this.reviewCounts.againCount;
              }
              break;
            case 7:
              if (this.reviewCounts.picFlagCount) {
                this.maxTotal = this.reviewCounts.picFlagCount;
              }
              break;
            default:
              break;
          }
        })
        .catch(err => {
          console.log(err);
        });
      url = `https://review.suning.com/ajax/getClusterReview_labels/${type}-${this.goodsInfo.comment_param.clusterId}-${this.goodsInfo.comment_param.sku}-${this.goodsInfo.comment_param.vendorCode}-----commodityrLabels.htm`;
      this.$http
        .jsonp(url, {
          jsonp: "callback",
          jsonpCallback: "commodityrLabels",
          dataType: "jsonp"
        })
        .then(res => {
          this.hotComments = res.data.commodityLabelCountList;
        });
    },
    getCommentList() {
      let url = "https://wy.shangbanzugroup.com/xhr/comment/tags.json";
      this.$http
        .jsonp(url, {
          jsonp: "callback",
          jsonpCallback: "satisfy",
          dataType: "jsonp",
          params: {
            itemId: this.comment_param.wangyiId
          }
        })
        .then(function(res) {
          this.totalItems = res.data.data;
          if (this.totalItems && this.totalItems[0]) {
            this.total = this.totalFormat(this.totalItems[0].strCount);
            this.$emit("setTotal", this.total);
          }
        });
    },
    getRate() {
      let url = "https://wy.shangbanzugroup.com/xhr/comment/itemGoodRates.json";
      this.$http
        .jsonp(url, {
          jsonp: "callback",
          jsonpCallback: "abc",
          dataType: "jsonp",
          params: {
            itemId: this.comment_param.wangyiId
          }
        })
        .then(res => {
          this.commentRateTxt = parseFloat(res.data.data.goodCmtRate);
          this.$emit("commentshow", this.commentRateTxt);
        });
    },
    handleCurrentChange(val) {
      this.Pinjia(val);
      document.getElementById("comment").scrollIntoView(true);
    },
    showBigCommentImage(url, index) {
      if (this.comment_param.supplier === "suning") {
        this.$set(this.bigImage, index, url);
      } else if (this.comment_param.supplier === "jd") {
        this.$set(this.playVideo, index, "");
        let mark = "";
        if (url.indexOf("//img30.360buyimg.com/n0/s") !== -1) {
          mark = "//img30.360buyimg.com/n0/s";
        } else {
          mark = "//img30.360buyimg.com/shaidan/s";
        }
        let size = url.split(mark)[1].split("_")[0];
        let newW = 400 / (size.split("x")[0] / size.split("x")[1]);
        let newUrl = mark + "400x" + newW + "_" + url.split("_")[1];
        this.$set(this.bigImage, index, newUrl);
      } else if (this.comment_param.supplier === "wangyi") {
        this.$set(this.bigImage, index, url);
      }
    },
    playVideo(src, index) {
      this.$set(this.bigImage, index, "");
      this.$set(this.playingVideo, index, src);
    },
    clearCommentImage(index) {
      this.$set(this.bigImage, index, "");
    },
    totalFormat(count) {
      if (!count) {
        return;
      }
      let newCount;
      if (count >= 10000) {
        newCount = parseInt(count / 10000) + "万+";
      } else {
        newCount = count;
      }
      return newCount;
    }
  }
};
</script>

<style lang="less" scoped>
.comment-wrap {
  min-height: 300px;
  font-size: 14px;
  .comment-title {
    padding-left: 10px;
    background: #f5f5f5;
    border: 1px solid #e4e4e4;
    > span {
      display: inline-block;
      padding: 0 15px;
      height: 32px;
      line-height: 35px;
      text-align: center;
      cursor: pointer;
      &.actived {
        color: #e4393c;
      }
    }
    .rate_txt {
      font-size: 16px;
      color: #e4393c;
      font-family: arial;
      font-weight: normal;
    }
  }
  .reviews-list {
    padding: 10px 15px;
    .reviews-item {
      padding: 10px 0;
      border-bottom: 1px solid #efefef;
    }
    .reviews-item:last-child {
      border-bottom: none;
    }
    .review-header {
      padding: 0 10px 0 0;
      float: left;
      width: 10%;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      .Names {
        height: 25px;
        width: 25px;
        border-radius: 50%;
        float: left;
        margin-right: 3px;
        img {
          border-radius: 50%;
        }
      }
      .nickname {
        zoom: 0.8;
      }
      .NameBox {
        width: 100%;
        float: left;
        color: #e1a10a;
        margin-top: 5px;
      }
    }
    .review-item-content {
      float: left;
      width: 88%;
      text-align: left;
      padding-left: 5px;
      .review-date {
        font-size: 14px;
        height: 27px;
        line-height: 27px;
      }
      .imgBox {
        width: 100%;
        float: left;
        margin-top: 10px;
        .imgList {
          position: relative;
          display: inline-block;
          width: 52px;
          height: 52px;
          float: left;
          margin-right: 5px;
          border: 1px solid gainsboro;
          text-align: center;
          img {
            width: 100%;
            height: 100%;
            cursor: pointer;
          }
          .play-btn {
            position: absolute;
            width: 30px;
            height: auto;
            top: 10px;
            left: 10px;
          }
        }
        .not-video {
          img {
            cursor: zoom-in;
          }
        }
      }
      .PlsPage {
        padding-top: 0px;
        padding-bottom: 0px;
        width: auto;
        height: auto;
        float: left;
        margin-top: 10px;
        img {
          width: auto;
          cursor: zoom-out;
        }
      }
      .video-wrap {
        display: block;
      }
      .titleBox {
        width: 100%;
        float: left;
        color: #999;
        margin-top: 10px;
        font-size: 12px;
      }

      .review-description {
        line-height: 26px;
      }
    }
  }
}
.hot-comment {
  padding: 10px 0;
  .commodityEvaluation {
    height: 40px;
    background: rgb(245, 245, 245);
    border: 1px solid rgb(228, 228, 228);
    line-height: 40px;
    padding-left: 12px;
    width: 98%;
    margin-left: 1%;
    margin-top: 13px;
    margin-bottom: 8px;
  }
  .good-rate-wrap {
    font-size: 12px;
    text-align: center;
    .good-rate {
      color: #e4393c;
      font-size: 20px;
    }
    .rate_txt {
      font-size: 30px;
      color: #e4393c;
    }
  }
  .hot-tag {
    display: inline-block;
    line-height: 20px;
    padding: 2px 9px;
    border: 1px solid #e0e0e0;
    border-radius: 2px;
    margin-right: 10px;
    margin-bottom: 10px;
    font-size: 12px;
    cursor: pointer;
    &:hover {
      border-color: #666;
      color: #666;
    }
    &.actived {
      color: #e4393c;
      border-color: #e4393c;
    }
  }
  .sn-hot {
    position: relative;
    float: left;
    height: 20px;
    margin: 0 10px 10px 0;
    padding: 0 10px;
    border: 1px solid #f3cba9;
    white-space: nowrap;
    background: #fff;
    line-height: 20px;
    color: #f60;
  }
}
.el-pagination {
  padding: 10px 15px;
  text-align: right;
  font-weight: normal;
}
.comment-wrap /deep/ .el-pager li {
  border: 1px solid #ddd;
  margin-right: 5px;
}
.comment-wrap /deep/ .el-pager li.active {
  color: #fff;
  background-color: #e2333f;
  border: 1px solid #e2333f;
}
.comment-wrap /deep/ .el-pager li:hover {
  color: #fff;
  background-color: #e2333f;
  border: 1px solid #e2333f;
}
</style>



// WEBPACK FOOTER //
// src/pages/products/comment.vue